module.exports = __webpack_public_path__ + "img/icon-map-implantation-08.03f2b940.svg";